@use "../../sass/global/global" as *;

ux-iws-nb-product-benefits {
    --background-color: #fff;
    --heading-color: #000;
    --text-color: #{$color-black-2};
    --line-color: #{$color-gray-borders};
}

.ux-iws-nb-product-benefits {
    display: block;
    position: relative;
    box-sizing: border-box;
    padding: 0;
    @include font(light);
    background-color: var(--background-color);
    color: var(--text-color);

    &__article {
        display: block;
        padding: 30px 15px;
        margin: 0;

        @media (min-width: 568px) {
            padding: 30px;
        }

        @media (min-width: 1024px) {
            padding-left: calc(100% / 12);
            padding-right: calc(100% / 12);
            padding-bottom: 60px;
            padding-top: 60px;
        }
    }

    &__title {
        display: block;
        margin-bottom: 30px;

        @media (min-width: 1440px) {
            margin-bottom: 60px;
        }
    }

    &__show-more {
        display: none;
        align-items: center;
        justify-content: center;
        margin-top: 30px;
    }

    [slot="title"],
    [slot="title"] h2,
    [slot="title"] h3 {
        @include font(bold);
        font-size: 20px;
        line-height: 1.2;
        color: var(--heading-color);
        margin: 0;

        @media (min-width: 1440px) {
            font-size: 23px;
        }
    }

    [slot="subtitle"] {
        color: var(--heading-color);
        margin: 0;
        @include nb-heading(2, false);
    }

    ul,
    li {
        margin: 0;
        padding: 0;
        list-style: none;
        box-sizing: border-box;
    }

    ul {
        display: flex;
        flex-flow: row wrap;
        align-items: stretch;
        justify-content: flex-start;
        width: 100%;
        row-gap: 30px;

        @media (min-width: 768px) {
            column-gap: 30px;
        }

        @media (min-width: 1440px) {
            column-gap: 120px;
        }
    }

    li {
        display: flex;
        flex-direction: column;
        flex: 0 0 auto;
        width: 100%;
        padding: 0 0 30px;
        @include font(light);
        font-size: 16px;
        line-height: 1.2;
        color: var(--text-color);
        border-bottom: 1px solid var(--line-color);

        @media (min-width: 768px) {
            width: calc(50% - 15px);
        }

        @media (min-width: 1440px) {
            width: calc(50% - 60px);
        }
    }

    li h3,
    li h4 {
        @include font(bold);
        font-size: 18px;
        line-height: 1.2;
        margin: 0 0 10px;
        color: var(--heading-color);

        @media (min-width: 1440px) {
            font-size: 20px;
        }
    }
}

.ux-iws-nb-product-benefits--light {
    --background-color: #fff;
    --heading-color: #000;
    --text-color: #{$color-black-2};
    --line-color: #{$color-gray-borders};
}

.ux-iws-nb-product-benefits--light-gray {
    --background-color: #f4f5f6;
    --heading-color: #000;
    --text-color: #{$color-black-2};
    --line-color: #{$color-gray-borders};
}

.ux-iws-nb-product-benefits--dark-blue {
    --background-color: #{$color-blue-1};
    --heading-color: #fff;
    --text-color: #fff;
    --line-color: #{$color-blue-2};
}

@media (max-width: 767px) {
    .ux-iws-nb-product-benefits:not(.ux-iws-nb-product-benefits--expanded) {
        .ux-iws-nb-product-benefits__show-more {
            display: flex;
        }
    }

    .ux-iws-nb-product-benefits:not(.ux-iws-nb-product-benefits--expanded) li {
        display: none;

        &:nth-of-type(1),
        &:nth-of-type(2),
        &:nth-of-type(3) {
            display: flex;
        }
    }
}
